import { Grid2 as Grid, Container, useMediaQuery, useTheme } from "@mui/material";
import OutstandingEdiInvoiceResultLink from "./OutstandingEdiInvoiceResultLink";
import { useStyles } from "./OutstandingEdiInvoiceCard.styles";
import { EdiTrackingOutstandingInvoiceCardListProps } from "./types";

export default function OutstandingEdiInvoiceCardList({ invoices, greenMinDays, yellowMinDays, redMinDays, onView }: EdiTrackingOutstandingInvoiceCardListProps) {
	const classes = useStyles();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<Container disableGutters>
			<Grid
				container
				direction="column"
				wrap={"nowrap"}
				className={classes.outstandingEdiInvoiceLinkContainer}
				spacing={isMobile ? 1 : 2}
			>
				{invoices.map((invoice) => (
					<Grid key={`${invoice.invoiceNumber}__${invoice.purchaseOrderNumber}`}>
						<OutstandingEdiInvoiceResultLink
							invoiceNumber={invoice.invoiceNumber}
							purchaseOrderNumber={invoice.purchaseOrderNumber}
							invoiceDate={invoice.invoiceDate}
							supplierName={invoice.supplierName}
							totalQuantity={invoice.itemQuantity}
							totalCostInc={invoice.itemAmount}
							onSelect={() => onView(invoice.invoiceNumber, invoice.purchaseOrderNumber)}
							highlight={false}
							daysOverdue={invoice.daysOverdue}
							greenMinDays={greenMinDays}
							yellowMinDays={yellowMinDays}
							redMinDays={redMinDays}
						/>
					</Grid>
				))}
			</Grid>
		</Container>
	);
}
